import { type ToastMessage } from 'primereact/toast';
import { ZodIssue } from "zod";

export const CustomErrorMessage = (error: Error | ZodIssue): ToastMessage => ({
    severity: 'error',
    summary: 'Oops!',
    detail: error.message
});
